export function popupSliderClose () {
	$('[data-popup-slider]').on('click', function (e) {
		if ($(e.target).is('.popup-slider__item') || $(e.target).parent().is('.popup-slider__item') || $(e.target).is('.slider__arrow') || $(e.target).parent().is('.slider__arrow')) {
			return;
		}
		$.magnificPopup.close();
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/popup-slider-close.js